export var isAnswerCorrect = function isAnswerCorrect(correctAnswers, answerId) {
  return correctAnswers.some(function (c) {
    return c.answerId === answerId;
  });
};
export var isAnswerSelected = function isAnswerSelected(selectedValues, answerId) {
  return selectedValues.some(function (value) {
    return value.answerId === answerId;
  });
};